import { render, staticRenderFns } from "./Day12.vue?vue&type=template&id=1b8cf0b6"
import script from "./Day12.vue?vue&type=script&lang=js"
export * from "./Day12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports